import { Injectable } from '@angular/core';
import { Subscription } from './subscription.model';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SubscriptionService {
  selectedSub: Subscription = {
    subType: '',
  };
  noAuthHeader = { headers: new HttpHeaders({ 'NoAuth': 'True' }) };
  constructor(private http: HttpClient) { }

  subs(body){
   //console.log('Inside subscribe', body);
    // return this.http.post(environment.apiBaseUrl + '/subscribe',this.noAuthHeader);

  }
}
